/*import Vue from 'vue'*/
import EventUtils from '@/utils/EventUtils.js';
import MapUtils from '@/utils/MapUtils.js';
import ConstUtils from '@/utils/ConstUtils.js'

const state = {
  list: [],
  map: {},
};

const getters = {
    InvoiceItemsStorage: state => state,
    InvoiceItemsStorage_size: state => state.list.length,
};

const actions = {
};

const mutations = {
  SOCKET_ONMESSAGE (state, event)  {
    if (event.status == EventUtils.STATUS.COMPLETE && event.statusCode == EventUtils.CODE.OK) {
      if (event.Payload && event.Payload.InvoiceItemMap) {
        var items = event.Payload.InvoiceItemMap;
        state.map = MapUtils.updateMap(items, state.map);
        state.list = Object.values(state.map);
      }
      if (event.Payload && event.Payload.InvoiceItem) {
        var obj = event.Payload.InvoiceItem;
        state.map[obj[ConstUtils.FIELDS.ID]] = obj;
        state.list = Object.values(state.map);
      }
    }
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};